import {
  TRANSCRIPT_IN_PROGRESS_STATUSES,
  type TranscriptStatus as TranscriptStatusType,
} from "@/constants";
import { MentionCard } from "@/types/MentionCard";
import { Spinner } from "@components/ui/spinner";
import { Alert, AlertTitle } from "@components/ui/alert";
import { Trans } from "@lingui/react/macro";

type TranscriptStatusProps = {
  transcriptStatus: MentionCard["episode"]["transcript_status"];
  hasTranscript: MentionCard["episode"]["has_transcript"];
};

export default function TranscriptStatus({
  transcriptStatus,
  hasTranscript,
}: TranscriptStatusProps) {
  if (!transcriptStatus || hasTranscript) {
    return null;
  }

  const isTranscriptionInProgress = (
    TRANSCRIPT_IN_PROGRESS_STATUSES as readonly TranscriptStatusType[]
  ).includes(transcriptStatus);

  if (isTranscriptionInProgress) {
    return (
      <Alert variant="blue" className="my-1">
        <Spinner />
        <AlertTitle>
          <Trans>
            Vi lyssnar fortfarande på det här avsnittet. Om vi upptäcker ett
            omnämnande kan du spela upp det snart.
          </Trans>
        </AlertTitle>
      </Alert>
    );
  }

  return null;
}
